export const FUNCTIONALITY_DATA = {
  LEAVE_TYPE: "leave/types",
  APPROVAL_MATRIX: "approval/positions",
};
